export default __webpack_public_path__ + "static/media/detail3.b658bd1a.jpeg";